import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { PopMsg } from "../../variables/data";

import "./../../Assets/css/Modal.css";
import "./../../Assets/css/utility.css";

export const AlertModal = ({
  showModal,
  setShowModal,
  modalSize,
  animation,
  handleOrder,
  st_id,
  loading,
}) => {
  const [message, setMessage] = useState([]);

  useEffect(() => {
    if (st_id) {
      let msg = PopMsg.filter((item) => item?.status === st_id);
      setMessage(msg);
    }
  }, [st_id]);
  const handleHide = () => {
    setShowModal(false);
  };
  const handleModal = (st, st_id) => {
    handleOrder(st, st_id);
  };

  return (
    <Modal
      show={showModal}
      size={modalSize}
      animation={animation}
      onHide={handleHide}
      centered
    >
      <div className="alertModal">
        <p className="text-center">{message[0]?.msg}</p>
        <div className="alert_buttons">
          <button
            className="btn_without_background"
            onClick={() => handleModal(1, st_id)}
          >
            {loading ? (
              <div className="spinner-border text-light" role="status"></div>
            ) : (
              ""
            )}
            Yes
          </button>
          <button className="btn_modal" onClick={() => handleModal(0, st_id)}>
            No
          </button>
        </div>
      </div>
    </Modal>
  );
};
